var gol_criticalAppVersion = 0;
var gol_opt = {};
var local_storage_key = "saveImgBase";
var gol_base64 = "";
// ios新协议
function kkmhhybrid_save_jpeg_image_base64() {
    hybrid({
        hybridParam: {
            schema: "kkmhhybrid",
            tagname: "localstorage_transfer",
        },
        param: {
            key: local_storage_key,
            type: 1,
        },
        callback: function (res) {
            gol_opt.callback && gol_opt.callback(res);
        }
    });
}
// android新协议
function kkmhhybrid_save_jpeg_image_base64_android() {
    hybrid({
        hybridParam: {
            schema: "kkmhhybrid",
            tagname: "save_jpeg_image_base64",
        },
        param: {
            imgData: gol_base64.split("base64,")[1],
        },
        callback: function (res) {
            gol_opt.callback && gol_opt.callback(res);
        }
    });
}

function ua() {
    var userAgent = navigator.userAgent.toLowerCase();
    if (/(iphone|ipod|ipad)/i.test(userAgent)) {
        return "ios"
    }
    if (/android/.test(userAgent)) {
        return "android"
    }
}

// 点击保存图片
function saveImg() {
    createBase64(gol_opt.img)
}
// 生成base64
function createBase64(img) {
    let imgbase64 = "";
    if (typeof img == 'object') {
        // 传入的是图片元素 
        imgbase64 = transEleToBase64(img);
        gol_base64 = imgbase64;

        saveToLocal(imgbase64)

    } else if (typeof img == 'string' && img.indexOf("http") == 0) {
        // 传入的是http/https图片地址
        new Promise((resolve, reject) => {
            let image = new Image();
            image.src = `${img}?v=${Math.random()}`;
            image.crossOrigin = "*";
            return image.onload = () => {
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                ctx.drawImage(image, 0, 0);
                let data_url = canvas.toDataURL();
                return resolve(data_url)
            }
        }).then((res) => {
            imgbase64 = res;
            gol_base64 = imgbase64;

            saveToLocal(imgbase64)

        }).catch(err => {

        })
    } else if (typeof img == 'string' && img.indexOf("base64") != -1) {
        // 传入的是base64字符串
        imgbase64 = img;
        gol_base64 = imgbase64;
        saveToLocal(imgbase64)
    }

}
// 图片元素转成base64
function transEleToBase64(img) {
    let width = img.width,
        height = img.height;
    let canvas = document.createElement("canvas");
    canvas.width = width * 2;
    canvas.height = height * 2;
    let ctx = canvas.getContext("2d");
    ctx.scale(2, 2);
    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL();
}

// 保存到localStorage
function saveToLocal(base64) {
    localStorage.setItem(local_storage_key, null);
    localStorage.setItem(local_storage_key, base64);
    set_new_old();
}
// 区分新、旧（ios，android）
function set_new_old() {
    if (gol_criticalAppVersion === undefined) {
        gol_criticalAppVersion = window.kkBaseInfo.appVersion;
    }

    // var allow = window.kkBaseInfo.allowToKkmhhybrid(gol_criticalAppVersion);        //新老协议无问题可正常调用。（临界版本为全局版本号）
    var allow = window.kkBaseInfo.allowToKkmhhybrid(gol_criticalAppVersion, -1);       //新协议有问题，无法预知哪个版本解决。（临界版本为582000+30000版本）
    // var allow = window.kkBaseInfo.allowToKkmhhybrid(gol_criticalAppVersion, 582000);   //新协议从有问题到已修复确认，需传递修复版本。（临界版本为582000）

    let curOs = ua();
    if (allow) {
        // 调用新协议
        let osType = { ios: saveToIos, android: kkmhhybrid_save_jpeg_image_base64_android };
        osType[curOs]();

    } else {
        // 调用旧协议
        let osType = { ios: saveToIos, android: saveToAndroidOld };
        osType[curOs]();
    }
}

// ios保存图片协议
// ios无老协议，开发协议时即为新协议
function saveToIos() {
    kkmhhybrid_save_jpeg_image_base64();
}

// android保存图片协议-旧
function saveToAndroidOld() {
    let saveResult = window.kkmh.saveJpegImageBase64(
        gol_base64.split("base64,")[1]
    );
    if (saveResult) {
        saveImgSuccess();
    } else {
        saveImgFail();
    }

    gol_opt.callback && gol_opt.callback(saveResult);

}

// 图片保存成功
function saveImgSuccess() {
    setTimeout(() => {
        // 图片保存成功，可在手机相册中查看
    }, 1000);
}

// 图片保存失败
function saveImgFail() {
    setTimeout(() => {
        // 图片保存失败，请重试
    }, 1000);
}


/**
 * 保存base64-jpeg数据到客户端相册<br>
 * kkmhhybrid://save_jpeg_image_base64 {@link https://}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */

function save_jpeg_image_base64(opt, criticalAppVersion) {
    gol_criticalAppVersion = criticalAppVersion
    gol_opt = opt;
    saveImg();
}

export default save_jpeg_image_base64;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kk/h5-sdk/src/save_jpeg_image_base64/index.js
// module id = null
// module chunks = 